/**
 * Takes and array of any type and shuffles the items into a random order
 * @see Fisher-Yates Shuffle: https://bost.ocks.org/mike/shuffle/
 * @param {Array}
 * @return {Array} New Array with items shuffled
 */
export function shuffleArray(array) {
  let currentIndex = array.length;
  let temporaryValue;
  let randomIndex;
  const shuffled = [...array];
  // while there remain elements to shuffle
  while (currentIndex !== 0) {
    // Pick a remaining element
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;
    // And swap it with the current element
    temporaryValue = shuffled[currentIndex];
    shuffled[currentIndex] = shuffled[randomIndex];
    shuffled[randomIndex] = temporaryValue;
  }
  return shuffled;
}

export default {
  shuffleArray,
};
